import React from "react";
import { useIntl } from "react-intl";

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

import { activation } from "../../../messages";
import { useBmapi } from "../../../utils/bmapi-context";

export function Rules({ value, onChange, formatValues }) {
  const intl = useIntl();
  const { bmapi } = useBmapi();

  return (
    <FormControl margin="normal" fullWidth>
      <Typography variant="h6" gutterBottom>
        {intl.formatMessage(activation.acceptTos, formatValues)}
      </Typography>
      <Typography gutterBottom>
        {intl.formatMessage(activation.acceptTosPart1, formatValues)}
      </Typography>
      <Typography gutterBottom>
        {intl.formatMessage(activation.acceptTosPart2, formatValues)}
      </Typography>
      <Typography gutterBottom>
        {intl.formatMessage(activation.acceptTosPart3, formatValues)}
      </Typography>
      {bmapi.settings.privacySingleCheck ? (
        <FormControlLabel
          control={<Checkbox required onChange={onChange} color="primary" />}
          label={intl.formatMessage(activation.agreeTos)}
        />
      ) : (
        <RadioGroup row value={value} onChange={onChange}>
          <FormControlLabel
            value={true}
            control={<Radio required color="primary" />}
            label={intl.formatMessage(activation.agreeTos)}
          />
          <FormControlLabel
            value={false}
            control={<Radio required color="primary" />}
            label={intl.formatMessage(activation.dontAgreeTos)}
          />
        </RadioGroup>
      )}
    </FormControl>
  );
}
